export default __webpack_public_path__ + "static/media/VISION SYSTEM.6810406d.png";